import {contarPropiedadSumaWheres} from "../../Servicios/BD/Contadores/contarPropiedadSumaWheres";
import {where} from "firebase/firestore";

export const obtenerSaldo = async () => {

    let w = [where('estado', '==', 'Aceptado'), where('tipo', '==', 'Deposito')];

    let depositos = await contarPropiedadSumaWheres({coleccion: 'depositos', propiedad: 'valor', wheres: w})

    let wRet = [where('tipo', '==', 'Inversion')];

    let inversion = await contarPropiedadSumaWheres({coleccion: 'depositos', propiedad: 'valor', wheres: wRet})

    console.log(depositos, inversion)

    return depositos - inversion

}